import Title from "../../../components/ui/Title";
import UserLayout from "../../../layouts/user";
import ReviewList from "./_components/ReviewList";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export default function UserReviewList() {
  return (
    <UserLayout title="পছন্দের কোর্স তালিকা" breadcrumb={breadcrumb}>
      <div className="pb-6 mb-6 border-b border-theme-zinc-200">
        <Title className="text-2xl">রিভিউ সমূহ</Title>
      </div>

      <ReviewList />
    </UserLayout>
  );
}
